import classnames from "classnames";
import profilePhoto from "assets/images/profile_photo.svg";
import styles from "./ImageField.module.scss";

const ImageField = ({ label, photoUrl, alt, className }) => {
  return (
    <div className={classnames(styles.wrapper, className)}>
      <label className={styles.label}>{label}</label>
      <div className={styles.container}>
        <img
          src={
            photoUrl
              ? photoUrl.startsWith("http")
                ? photoUrl
                : `data:image/jpeg;base64,${photoUrl}`
              : profilePhoto
          }
          alt={alt}
          className={styles.photo}
        />
      </div>
    </div>
  );
};

export default ImageField;
